// extracted by mini-css-extract-plugin
export default {"container":"osgS31jpxp4xfholb8v-OHSMJ7nUCVVG7bQqnhmWfwg="};